import request from '../untils/request';

export const adminMessageListApi = params => {
  return request({
    url: '/common/admin-message/index',
    params,
  });
};

export const adminMessageNumApi = params => {
  return request({
    url: '/common/admin-message/num',
    params,
  });
};

export const adminDownloadedApi = params => {
  return request({
    url: '/common/admin-message/downloaded',
    params,
  });
};
